export const CHANGE_TRUCK_INFO = "CHANGE_TRUCK_INFO";
export const CLEAN_TRUCK_INFO = "CLEAN_TRUCK_INFO";
